import { Field, Form, Formik } from "formik";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector, connect } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import { push } from "connected-react-router";
import { actions as thirdPaymentActions, selectors as thirdPaymentSelectors } from "reducers/thirdPayment";
import { selectors as sessionSelectors } from "reducers/session";
import CustomData from "pages/_components/CustomData/CustomData";
import * as i18n from "util/i18n";
import * as config from "util/config";
import * as numberUtils from "util/number";
import FormattedAmount from "pages/_components/FormattedAmount";

import PropTypes, { string } from "prop-types";

import DocumentUploader from "./_components/DocumentUploader";

const FORM_ID = "payroll.loadRequest";

const LoadRequest = ({ environment, fileId }) => {
    const dispatch = useDispatch();

    const { documentToUploadRequest = {}, externalUploadError = null } = useSelector((state) => state.thirdPayment);

    const initialValues = {};

    const handleSubmit = () => {
        const documentToConfirm = {
            documentName: documentToUploadRequest?.value.documentId,
            totalRecords: documentToUploadRequest?.value?.totalRecords,
            totalAmount: documentToUploadRequest?.value?.totalAmount,
        };

        dispatch(thirdPaymentActions.setDocumentToConfirm(documentToConfirm));
        dispatch(push("/massPayroll/confirm"));
    };

    const [formValues, setFormValues] = useState(initialValues);

    const payrollStart = config.getInteger("payroll.window.startHour") || 10;
    const payrollEnd = config.getInteger("payroll.window.endHour") || 16;

    const window = { payrollStart, payrollEnd };

    const documentId = documentToUploadRequest?.value?.documentId;
    const totalRecords = documentToUploadRequest?.value?.totalRecords;
    const totalAmount = documentToUploadRequest?.value?.totalAmount;

    const isFormComplete = () => documentId;

    return (
        <>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values }) => {
                    setFormValues(values);
                    return (
                        <Form>
                            <GridTable className="form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data
                                        columnStart={2}
                                        flexDirection="column"
                                        columnWidth={10}
                                        key={documentId}>
                                        <CustomText
                                            className="document-title"
                                            text={`${FORM_ID}.document.label`}
                                            textType="I18N"
                                        />
                                        <Field
                                            component={DocumentUploader}
                                            idForm={FORM_ID}
                                            name="payrollDocument"
                                            label={`${FORM_ID}.upload.label`}
                                            extensionDocument="xlsx"
                                            documentCode="1"
                                            defaultDocument={{
                                                documentId,
                                                documentName: documentId,
                                            }}
                                            withDocumentName
                                            allowedTypes={["xlsx", "xls"]}
                                            externalUploadError={externalUploadError}
                                            totalRecords={totalRecords}
                                            totalAmount={totalAmount}
                                            environmentCuit={environment?.activeEnvironmentDocument}
                                            fileId={fileId}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>

                            {totalRecords && (
                                <>
                                    <br />
                                    <GridTable className="form-summary grid-table-form">
                                        <GridTable.Container>
                                            <GridTable.Data columnStart={1} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get(`payroll.loadRequest.totalRecords.label`)}
                                                    titleTextType="TEXT"
                                                    valueTextType="TEXT"
                                                    valueText={totalRecords}
                                                />
                                            </GridTable.Data>
                                            <GridTable.Data columnStart={3} rowStart={1}>
                                                <CustomData
                                                    titleText={i18n.get(`payroll.loadRequest.totalAmount.label`)}
                                                    titleTextType="TEXT"
                                                    valueTextType="TEXT"
                                                    valueText={
                                                        <FormattedAmount
                                                            currency="ARS"
                                                            quantity={numberUtils.formatAmountStrDouble(totalAmount)}
                                                        />
                                                    }
                                                />
                                            </GridTable.Data>
                                        </GridTable.Container>
                                    </GridTable>
                                </>
                            )}
                            <br />
                            <CustomData
                                icon="information_fill.svg"
                                titleText={i18n.get("payroll.service.reminder1", null, window)}
                                keepSpaceIfNoValue={false}
                            />
                            <br />
                            <CustomData
                                icon="information_fill.svg"
                                titleText="payroll.service.reminder2"
                                titleTextType="I18N"
                                keepSpaceIfNoValue={false}
                            />
                            <br />
                            <CustomData
                                icon="information_fill.svg"
                                titleText="payroll.service.reminder3"
                                titleTextType="I18N"
                                keepSpaceIfNoValue={false}
                            />

                            <Row className="form-actions">
                                <Col xs={12} md={4} mdOffset={4}>
                                    <Button
                                        type="submit"
                                        className="btn-primary"
                                        label="global.continue"
                                        loading={false}
                                        disabled={!isFormComplete()}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
};

LoadRequest.propTypes = {
    fileId: string.isRequired,
    environment: PropTypes.shape({
        activeEnvironmentDocument: string,
    }).isRequired,
};

const mapStateToProps = (state) => ({
    environment: sessionSelectors.getActiveEnvironment(state),
    fileId: thirdPaymentSelectors.getPayrollFileId(state),
});
export default connect(mapStateToProps)(LoadRequest);
